"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badgePropTypes = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _interfaces = require("./interfaces");

var badgePropTypes = {
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.BadgeColorScheme)).description('Determines the color scheme of the Badge.'),
  type: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.BadgeType)).description('Determines the background color of the Badge.'),
  value: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]).description('Value to be shown inside of the Badge.') // variant: PropTypes.oneOf(Object.values(BadgeVariant)).description(
  //   'Determines the variant of the Badge.'
  // )

};
exports.badgePropTypes = badgePropTypes;